/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FavoriteItem
 */
export interface FavoriteItem {
    /**
     * 
     * @type {number}
     * @memberof FavoriteItem
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof FavoriteItem
     */
    contentfulType: string | null;
    /**
     * 
     * @type {string}
     * @memberof FavoriteItem
     */
    contentfulId: string | null;
}

/**
 * Check if a given object implements the FavoriteItem interface.
 */
export function instanceOfFavoriteItem(value: object): value is FavoriteItem {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('contentfulType' in value) || value['contentfulType'] === undefined) return false;
    if (!('contentfulId' in value) || value['contentfulId'] === undefined) return false;
    return true;
}

export function FavoriteItemFromJSON(json: any): FavoriteItem {
    return FavoriteItemFromJSONTyped(json, false);
}

export function FavoriteItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FavoriteItem {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'contentfulType': json['contentfulType'],
        'contentfulId': json['contentfulId'],
    };
}

export function FavoriteItemToJSON(json: any): FavoriteItem {
    return FavoriteItemToJSONTyped(json, false);
}

export function FavoriteItemToJSONTyped(value?: FavoriteItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'contentfulType': value['contentfulType'],
        'contentfulId': value['contentfulId'],
    };
}

